import React from "react";

import CheckIcon from "@mui/icons-material/Check";
import { Box, Button, Dialog, Stack, Typography } from "@mui/material";
import Parameters from "assets/images/Parameters.png";

interface Props {
  open: boolean;
  onClose: () => void;
}

export const ExtractDataGuideDialog: React.FC<Props> = ({ open, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    slotProps={{
      paper: {
        sx: {
          borderRadius: "8px",
          p: "24px",
          gap: "20px",
          maxWidth: 560,
          width: "100%",
          boxShadow:
            "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)"
        }
      }
    }}
  >
    <Typography sx={{ fontSize: "18px", fontWeight: 400, lineHeight: "24px", color: "#071f35", pb: "8px" }}>
      Extract Data
    </Typography>

    <Stack alignItems="center" gap="20px">
      <Box sx={{ height: 144, width: 315, overflow: "hidden" }}>
        <Box
          component="img"
          src={Parameters}
          alt=""
          sx={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "top" }}
        />
      </Box>

      <Stack gap="8px" sx={{ width: "100%" }}>
        <Stack direction="row" alignItems="center" gap="30px">
          <Stack direction="row" sx={{ width: 99, flexShrink: 0 }}>
            <Box sx={{ width: 24, height: 24, bgcolor: "rgba(255, 217, 0, 0.2)" }} />
            <Box
              sx={{
                width: 54,
                height: 24,
                bgcolor: "rgba(255, 217, 0, 0.2)",
                display: "flex",
                alignItems: "center",
                pl: "8px"
              }}
            >
              <Typography sx={{ fontSize: "16px", lineHeight: "24px", color: "#0a3142" }}>$100</Typography>
            </Box>
          </Stack>
          <Typography
            component="li"
            sx={{ fontSize: "15px", lineHeight: "20px", color: "#0a3142", listStyleType: "disc" }}
          >
            Click a yellow field to tag data.
          </Typography>
        </Stack>

        <Stack direction="row" alignItems="center" gap="30px">
          <Stack direction="row" sx={{ width: 99, flexShrink: 0 }}>
            <Box
              sx={{
                width: 24,
                height: 24,
                bgcolor: "#188100",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Typography sx={{ fontSize: "14px", fontWeight: 700, lineHeight: "16px", color: "white" }}>3</Typography>
            </Box>
            <Box
              sx={{
                width: 54,
                height: 24,
                bgcolor: "rgba(24, 129, 0, 0.2)",
                display: "flex",
                alignItems: "center",
                pl: "8px"
              }}
            >
              <Typography sx={{ fontSize: "16px", lineHeight: "24px", color: "#0a3142" }}>$100</Typography>
            </Box>
          </Stack>
          <Typography
            component="li"
            sx={{ fontSize: "15px", lineHeight: "20px", color: "#0a3142", listStyleType: "disc" }}
          >
            Green fields are suggestions from AI or other users.
          </Typography>
        </Stack>

        <Stack direction="row" alignItems="center" gap="30px">
          <Stack direction="row" sx={{ width: 99, flexShrink: 0 }}>
            <Box
              sx={{
                width: 24,
                height: 24,
                bgcolor: "#188100",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Typography sx={{ fontSize: "14px", fontWeight: 700, lineHeight: "16px", color: "white" }}>3</Typography>
            </Box>
            <Box
              sx={{
                width: 54,
                height: 24,
                bgcolor: "rgba(24, 129, 0, 0.2)",
                display: "flex",
                alignItems: "center",
                pl: "8px"
              }}
            >
              <Typography sx={{ fontSize: "16px", lineHeight: "24px", color: "#0a3142" }}>$100</Typography>
            </Box>
            <CheckIcon sx={{ fontSize: 20, color: "#07a27d", ml: "2px" }} />
          </Stack>
          <Typography
            component="li"
            sx={{ fontSize: "15px", lineHeight: "20px", color: "#0a3142", listStyleType: "disc" }}
          >
            A ✓ means the item is already saved to the deal ledger.
          </Typography>
        </Stack>
      </Stack>

      <Typography sx={{ fontSize: "15px", fontWeight: 500, lineHeight: "20px", color: "#0a3142", width: "100%" }}>
        Select a yellow value to map it to the right parameter. Review suggestions before saving.
      </Typography>
    </Stack>

    <Stack direction="row" justifyContent="flex-end">
      <Button
        onClick={onClose}
        sx={{
          borderRadius: "32px",
          bgcolor: "#071f35",
          color: "white",
          textTransform: "none",
          px: "16px",
          py: "4px",
          fontSize: "16px",
          fontWeight: 400,
          lineHeight: "24px",
          "&:hover": { bgcolor: "#0a2a45" }
        }}
      >
        OK
      </Button>
    </Stack>
  </Dialog>
);
